

































































import { Component, Vue, Prop } from 'vue-property-decorator';
import LineIndicator from '@/components/common/LineIndicator.vue';
import FaunaTagPreview from '@/components/common/FaunaTagPreview.vue';

import faunaTagDialog from '@/fauna-tag-dialog';
import PieChart from '@/components/common/PieChart.vue';

import { FaunaSurvey, SurveyProperty, SurveySite } from '@/api';
import cacheModule from '@/store/Cache';
import propertyModule from '@/store/Property';

import { numberFormat } from '@/util';

import * as d3 from 'd3';

@Component({
  components: {
    FaunaTagPreview,
    LineIndicator,
    PieChart,
  },
})
export default class FaunaStatsLines extends Vue {
  @Prop({ default: null }) readonly property: SurveyProperty;

  @Prop({ default: null }) readonly site: SurveySite;

  @Prop({ default: null }) readonly survey: FaunaSurvey;

  fullList = false;

  get numberFormat() {
    return numberFormat;
  }

  get faunaStats() {
    if (this.survey) {
      return propertyModule.surveyStats(this.survey.id as string, 'fauna_tag');
    }
    if (this.site) {
      return propertyModule.siteStats(this.site.id as string, 'fauna_tag');
    }
    return propertyModule.propertyStats(
      this.property.id as string,
      'fauna_tag',
    );
  }

  get tags() {
    if (!this.faunaStats) {
      return [];
    }
    const color = d3.scaleOrdinal(d3.schemeTableau10);
    return this.faunaStats
      .filter(fs => fs.faunaTag && fs.count)
      .map((fs, i) => {
        const id = (fs.faunaTag as number).toString();
        const tag = cacheModule.faunaTagsById(id);
        return tag
          ? {
              name: tag.name,
              picture: tag.avatarUrl,
              value: fs.count,
              tag,
              color: color(i.toString()),
            }
          : {
              name: 'Unknown',
              picture: '',
              value: fs.count,
              color: color(i.toString()),
            };
      });
  }

  get shownTags() {
    return this.fullList ? this.tags : this.tags.slice(0, 3);
  }

  get max() {
    return this.tags.reduce((sum, item) => sum + item.value, 0);
  }

  get pieData() {
    return this.tags.map((tag, i) => ({
      label: tag.name,
      value: tag.value,
      color: tag.color,
    }));
  }

  showDialog(faunaTagId?: string) {
    faunaTagDialog(faunaTagId);
  }

  async mounted() {
    if (this.survey) {
      propertyModule.getSurveyTagStats(this.survey.id as string);
    } else if (this.site) {
      propertyModule.getSiteTagStats(this.site.id as string);
    } else {
      propertyModule.getPropertyTagStats(this.property.id as string);
    }
  }
}
